import React from "react";

export default function Step2() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          2
        </div>
        <h1 className="">
          Agora, clique em <b>ACEITAR TODOS</b>.
        </h1>
      </div>
      <div className="mt-2.5 ml-[42px]">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/steady-gainz.firebasestorage.app/o/OpenAccount%2FIMG_3605.jpg?alt=media&token=54d856bb-ee20-4a07-9e29-0ca195fb5833"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
